import { manDoor, dockDoor } from '~/config/doors'
import LAYER_KEYS, { LayerKeys } from '~/config/layerKeys'
import { MenuDropDownButton } from '../components/MenuDropDownButton'
import { MenuItem } from '~/ui/Menu'
import { useAppDispatch } from '~/store/hooks'
import { setCurrentLayer } from '~/store/layers'
import { setActiveTool } from '~/store/tools'
import { Icon } from '~/ui/Icon'
import { SetActiveToolPayload } from '~/store/tools/reducer'

export default function WallsAndDoorsMenu() {
  const dispatch = useAppDispatch()
  const action = (layerKey: LayerKeys, toolPayload: SetActiveToolPayload) => () => {
    dispatch(setCurrentLayer({ layerKey }))
    dispatch(setActiveTool(toolPayload))
  }
  return (
    <MenuDropDownButton label="Walls & Doors" icon="interiorWall">
      <MenuItem onAction={action(LAYER_KEYS.EXTERIOR_WALLS, { tool: 'LINE_TOOL' })} variant="square">
        <Icon name="square" size="14" />
        Exterior Wall
      </MenuItem>
      <MenuItem onAction={action(LAYER_KEYS.INTERIOR_WALLS, { tool: 'LINE_TOOL' })} variant="square">
        <Icon name="interiorWall" size="14" />
        Interior Wall
      </MenuItem>
      <MenuItem onAction={action(LAYER_KEYS.DOORS, { tool: 'DOOR_TOOL', props: manDoor })} variant="square">
        <Icon name="doorMan" size="14" />
        Man Door
      </MenuItem>
      <MenuItem onAction={action(LAYER_KEYS.DOORS, { tool: 'DOOR_TOOL', props: dockDoor })} variant="square">
        <Icon name="doorDock" size="14" />
        Dock Door
      </MenuItem>
    </MenuDropDownButton>
  )
}
